import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';

export const TrialExpiredRedirect: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { trialJustExpired } = useSubscription();

  useEffect(() => {
    if (trialJustExpired && location.pathname !== '/trial-expired') {
      navigate('/trial-expired');
    }
  }, [trialJustExpired, navigate, location.pathname]);

  return null;
};
